<template>
    <div class="columns is-multiline film_list practics_list"  style="margin-top: 25px;">
				<template v-for="film in practices" :key="film.id">
            <div v-if="!isShowActionsBlock && film.isPublished || isShowActionsBlock"  class="column is-3 practic_item" :class="[!isShowActionsBlock ? 'practic_item_view' : 'practic_item_edit', film.project_data?.status === 'Реализована' ? 'realize_practic' : '', film.project_data?.status === 'В производстве' ? 'production_practic' : '']">
                <p class="film_item_p"><a style="" :href="'/other_practic/'+ film.id">{{ film.name }}</a></p>
                <div class="film_type_block">
                    <div class="production" v-if="!film.isPublished">Черновик</div>
                    <template v-else>
                        <div class="realize" v-if="film.project_data?.status === 'Реализована'">
                            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_1735_2822)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8187 6.63502L14.5984 10.1814L15.779 15.3603C15.8251 15.5649 15.7375 15.7758 15.5553 15.8988C15.3739 16.0211 15.1319 16.034 14.9366 15.9296L9.99999 13.2915L5.06944 15.9296C4.87422 16.034 4.63211 16.0211 4.44997 15.8988C4.26859 15.7758 4.18097 15.5649 4.22709 15.3603L5.40763 10.1814L1.18128 6.63502C1.01911 6.49414 0.95916 6.27889 1.02833 6.08223C1.09674 5.88557 1.28197 5.74468 1.50177 5.71965L7.15855 5.1597L9.47891 0.315382C9.57037 0.123721 9.77481 0 10 0C10.2252 0 10.4296 0.123718 10.5211 0.315382L12.8415 5.15256L18.4982 5.71251C18.718 5.73754 18.9033 5.87843 18.9717 6.07509C19.0408 6.27104 18.9809 6.48701 18.8187 6.62788L18.8187 6.63502Z" fill="white" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_1735_2822" x="0" y="0" width="20" height="18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="1" />
                                        <feGaussianBlur stdDeviation="0.5" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1735_2822" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1735_2822" result="shape" />
                                    </filter>
                                </defs>
                            </svg> <span>реализован</span>
                        </div>
                        <div class="production" v-if="film.project_data?.status === 'В производстве'">
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.50215 11.9154C6.20447 11.9154 6.77382 11.3454 6.77382 10.6423C6.77382 9.93915 6.20447 9.36914 5.50215 9.36914C4.79982 9.36914 4.23047 9.93915 4.23047 10.6423C4.23047 11.3454 4.79982 11.9154 5.50215 11.9154Z" fill="#1D232D" />
                                <path d="M10.0568 11.9154C10.7592 11.9154 11.3285 11.3454 11.3285 10.6423C11.3285 9.93915 10.7592 9.36914 10.0568 9.36914C9.35451 9.36914 8.78516 9.93915 8.78516 10.6423C8.78516 11.3454 9.35451 11.9154 10.0568 11.9154Z" fill="#1D232D" />
                                <path d="M14.6154 11.9154C15.3178 11.9154 15.8871 11.3454 15.8871 10.6423C15.8871 9.93915 15.3178 9.36914 14.6154 9.36914C13.9131 9.36914 13.3438 9.93915 13.3438 10.6423C13.3438 11.3454 13.9131 11.9154 14.6154 11.9154Z" fill="#1D232D" />
                                <path d="M9.98844 0.734985C4.48555 0.734985 0 5.22573 0 10.735C0 16.2442 4.48555 20.735 9.98844 20.735C15.4913 20.735 20 16.2674 20 10.735C20 5.22573 15.5145 0.734985 9.98844 0.734985ZM9.98844 19.3692C5.24856 19.3692 1.38728 15.5035 1.38728 10.7581C1.38728 6.01276 5.24856 2.14702 9.98844 2.14702C14.7283 2.14702 18.5896 6.01276 18.5896 10.7581C18.6127 15.5035 14.7514 19.3692 9.98844 19.3692Z" fill="#1D232D" />
                            </svg> <span>в производстве</span>
                        </div>
                    </template>
                </div>
                <div class="film_item_elems" v-if="isShowActionsBlock">
                    <a style="" :href="'/project/other_practices/'+film.id"><i
                            class="far fa-edit" style="margin-left: 0; margin-right: 20px;"></i></a>
                    <Popconfirm
                            title="Вы действительно хотите удалить эту практику?"
                            ok-text="Да"
                            cancel-text="Нет"
                            @confirm="delete_film(film.id)"
                            @cancel="() => {}"
                    >
                        <a style="" class="delete_link"><i
                                class="far fa-trash-alt"></i></a>
                    </Popconfirm>
                </div>
            </div>
				</template>
    </div>
</template>
<script setup>
import { Popconfirm } from "ant-design-vue";
import {defineEmits, defineProps, toRefs} from 'vue'
import axios from "axios";

const props = defineProps({
  practices: {},
  isShowActionsBlock: {
    type: Boolean
  }
})
const { practices } = toRefs(props);

const emit = defineEmits(['update']);

async function delete_film(id) {
  await axios.get('/project/delete_ajax/'+id);
  emit('update')
}
</script>

<style scoped>
.film_list .film_item {
    max-width: 280px;
}
.film_item {
    display: flex;
    flex-direction: column;
}
.film_item_p {
    flex-grow: 1;
    font-weight: 700;
    margin-bottom: 10px;
    font-size: 18px;
		line-height: normal;
}
.film_item img {
    border-radius: 10px;
}

.film_item_elems {
    display: flex;
    margin-left: 15px;
    justify-content: end;
}
.film_item_p__wrapper {
    margin-top: 20px;
}
.practic_item {
		display: flex;
		flex-direction: column;
}
.film_item_p {
		flex-grow: 1;
}
.practic_item {
    border: 1px solid rgb(239, 162, 79);
    padding: 15px;
    background: rgb(248, 248, 248);
    border-radius: 10px;
    width: 280px;
    margin-right: 20px;
}
.practics_list {
    margin-left: 0;
    margin-right: 0;
}
.practic_item_view {
    border-radius: 12px;
    border: 1px solid #F7C100;
    background: linear-gradient(92deg, #F7C100 0.01%, #F69400 100%);
}
.film_item_p a {
		color: #000;
}
.practic_item_view .film_item_p a {
    font-weight: 700;
    color: #FFF;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.10);
}

.practics_list .column {
    margin-bottom: 20px;
}
.film_item_elems {
    display: flex;
    justify-content: space-between;
    margin-left: 0;
}
.realize {
    background: none;
    color: #fff;
    text-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    padding: 7px 12px;
    border: 1px solid #fff;
    border-radius: 222px;
}
.realize svg {
    margin-right: 10px;
}
.realize span {
    margin-top: -2px;
}


.production {
    background: none;
    color: #1d232d;
    text-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
    padding: 7px 12px;
    border-radius: 222px;
    border: 1px solid #1d232d;
}
.production svg {
    margin-right: 10px;
}
.production span {
    margin-top: -2px;
}
.film_item_elems {
    margin-top: 20px;
}
.production_practic {
		background: #fff;
    border: 1px solid #222;
    border-radius: 12px;
}
.practic_item_view.production_practic .film_item_p a {
    font-weight: 600;
    font-size: 18px;
    color: rgba(29, 35, 45, 0.6);
		text-shadow: none;
}
.practic_item_edit .realize {
    background: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    color: #fff;
}
</style>